// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_3oxlr","visuallyhidden":"_3Hptr","hide-text":"_1OShY","center":"_1mI7L","noprint":"_1qTbf","nt-bundle":"_37Mvq"};


/*****************
 ** WEBPACK FOOTER
 ** ./themes/ui-nt-bundle/styles/sports.scss
 ** module id = 344
 ** module chunks = 2
 **/